import React from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';

const ServicesPage: React.FC = () => {
  const services = [
    {
      id: 1,
      title: "Besplatna Procena",
      description: "Profesionalna procena prostora i potreba za segmentnim vratima. Naši stručnjaci dolaze na vašu adresu, rade precizna merenja i daju detaljnu procenu troškova potpuno besplatno.",
      features: ["Dolazak na teren", "Precizna merenja", "Detaljnu procenu", "Savet o najboljim opcijama", "Bez obaveze"],
      icon: "ri-ruler-line",
      image: "https://readdy.ai/api/search-image?query=professional%20garage%20door%20measurement%20service%20expert%20technician%20with%20measuring%20tools%20garage%20opening%20assessment%20free%20consultation%20professional%20evaluation%20quality%20service&width=400&height=300&seq=10&orientation=landscape"
    },
    {
      id: 2,
      title: "Profesionalna Ugradnja",
      description: "Stručna montaža segmentnih vrata. Koristi se najsavremenija oprema i tehnike ugradnje koje garantuju dugotrajnost i bezbednost vaših vrata.",
      features: ["Kvalitet", "Stručni tim", "Moderne tehnike", "Garancija na rad", "Brza realizacija"],
      icon: "ri-tools-line",
      image: "https://readdy.ai/api/search-image?query=professional%20garage%20door%20installation%20process%20sectional%20door%20mounting%20expert%20technicians%20quality%20workmanship%20modern%20garage%20installation%20service%20professional%20equipment&width=400&height=300&seq=11&orientation=landscape"
    },
    {
      id: 3,
      title: "Automatizacija Sistema",
      description: "Ugradnja i podešavanje automatskih sistema za segmentna vrata. Daljinski upravljači, senzori bezbednosti i najnovija tehnologija za vašu udobnost.",
      features: ["Daljinski upravljač", "Senzori bezbednosti", "LED osvetljenje", "Wi-Fi povezivanje", "Aplikacija za telefon"],
      icon: "ri-remote-control-line",
      image: "https://readdy.ai/api/search-image?query=automatic%20garage%20door%20opener%20installation%20professional%20technician%20installing%20motor%20system%20remote%20control%20modern%20automation%20technology%20sectional%20door%20automation&width=400&height=300&seq=12&orientation=landscape"
    },
    {
      id: 4,
      title: "Servis i Održavanje",
      description: "Redovan servis i preventivno održavanje segmentnih vrata. Osiguravamo optimalne performanse, produžavamo životni vek i sprečavamo neočekivane kvarove.",
      features: ["Preventivni pregled", "Podmazivanje delova", "Kalibracija sistema", "Zamena potrošnih delova", "24/7 hitna pomoć"],
      icon: "ri-settings-3-line",
      image: "https://readdy.ai/api/search-image?query=garage%20door%20maintenance%20service%20professional%20technician%20repairing%20sectional%20door%20quality%20service%20maintenance%20tools%20preventive%20care%20professional%20maintenance%20work&width=400&height=300&seq=13&orientation=landscape"
    },
    {
      id: 5,
      title: "Hitne Popravke",
      description: "Brze i pouzdane popravke segmentnih vrata u slučaju kvara. Dostupni smo 24/7 za hitne intervencije jer razumemo koliko su vam funkcionalna vrata važna.",
      features: ["24/7 dostupnost", "Brza reakcija", "Rezervni delovi", "Iskusni tehničari", "Garancija na popravku"],
      icon: "ri-tools-fill",
      image: "https://readdy.ai/api/search-image?query=emergency%20garage%20door%20repair%20service%20professional%20technician%20fixing%20sectional%20door%20urgent%20repair%20work%20quality%20service%20tools%20emergency%20maintenance%20professional%20help&width=400&height=300&seq=14&orientation=landscape"
    },
    {
      id: 6,
      title: "Konsultacije i Saveti",
      description: "Stručne konsultacije o izboru najpogodnijih segmentnih vrata za vaše potrebe. Pomažemo vam da donesete najbolju odluku na osnovu vašeg budžeta i zahteva.",
      features: ["Stručni saveti", "Analiza potreba", "Preporuke modela", "Pomoć pri izboru", "Dugoročna podrška"],
      icon: "ri-user-star-line",
      image: "https://readdy.ai/api/search-image?query=garage%20door%20consultation%20service%20professional%20advisor%20showing%20door%20options%20customer%20consultation%20expert%20advice%20quality%20service%20professional%20guidance%20sectional%20doors&width=400&height=300&seq=15&orientation=landscape"
    }
  ];

  const processSteps = [
    {
      step: 1,
      title: "Kontakt i Zakazivanje",
      description: "Pozovite nas ili pošaljite upit preko sajta. Zakazujemo termin za besplatnu procenu."
    },
    {
      step: 2,
      title: "Procena na Licu Mesta",
      description: "Naš stručnjak dolazi, meri prostor i daje detaljnu procenu sa preporukom."
    },
    {
      step: 3,
      title: "Ponuda i Dogovor",
      description: "Dobijate detaljnu ponudu sa specifikacijama. Dogovaramo termine i detalje."
    },
    {
      step: 4,
      title: "Profesionalna Ugradnja",
      description: "Naš tim vrši stručnu ugradnju sa garancijom kvaliteta i bezbednosti."
    }
  ];

  return (
    <div className="min-h-screen">
      <Header />
      
      {/* Hero Section */}
      <section className="relative pt-24 pb-16 min-h-[60vh] flex items-center">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: `url('https://readdy.ai/api/search-image?query=professional%20garage%20door%20services%20hero%20background%20installation%20process%20sectional%20doors%20quality%20workmanship%20expert%20technicians%20modern%20garage%20professional%20service&width=1920&height=800&seq=16&orientation=landscape')`
          }}
        ></div>
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 to-black/30"></div>
        
        <div className="relative z-10 container mx-auto px-6">
          <div className="max-w-3xl">
            <h1 className="text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
              Profesionalne Usluge
            </h1>
            <p className="text-xl lg:text-2xl text-gray-200 mb-8 leading-relaxed">
              Od merenja do finalne montaže - kompletan spektar usluga za vaša segmentna vrata
            </p>
            <Button 
              variant="primary" 
              size="lg"
              icon="ri-phone-line"
              href="tel:+381111234567"
            >
              Pozovite za Procenu
            </Button>
          </div>
        </div>
      </section>

      {/* Services Grid Section */}
      <section className="py-24 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              Naše Usluge
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Pružamo kompletne usluge ugradnje, servisiranja i održavanja segmentnih garažnih vrata
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service) => (
              <div key={service.id} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">
                <div className="h-48 bg-gray-100 p-4">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover rounded-xl"
                  />
                </div>
                
                <div className="p-8">
                  <div className="w-12 h-12 bg-red-600 rounded-lg flex items-center justify-center mb-4">
                    <i className={`${service.icon} text-2xl text-white`}></i>
                  </div>
                  
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">
                    {service.title}
                  </h3>
                  
                  <p className="text-gray-600 mb-6 leading-relaxed">
                    {service.description}
                  </p>
                  
                  <ul className="space-y-2">
                    {service.features.map((feature, index) => (
                      <li key={index} className="flex items-center text-gray-700">
                        <i className="ri-check-line text-red-600 mr-2"></i>
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="py-24 bg-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              Kako Funkcioniše Naš Proces
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Jednostavan i transparentan proces od prvog kontakta do finalne ugradnje
            </p>
          </div>
          
          <div className="relative">
            
            <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
              {processSteps.map((step, index) => (
                <div key={step.step} className="relative">
                  {/* Step Circle */}
                  <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center text-white text-2xl font-bold mb-6 mx-auto lg:mx-0 relative z-10">
                    {step.step}
                  </div>
                  
                  {/* Content */}
                  <div className="text-center lg:text-left">
                    <h3 className="text-xl font-bold text-gray-900 mb-3">
                      {step.title}
                    </h3>
                    <p className="text-gray-600">
                      {step.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 bg-red-600">
        <div className="container mx-auto px-6 text-center">
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
            Spremni za Profesionalnu Uslugu?
          </h2>
          <p className="text-xl text-red-100 mb-8 max-w-2xl mx-auto">
            Kontaktirajte nas danas za besplatnu procenu i počnite put ka novim kvalitetnim segmentnim vratima
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button 
              variant="secondary" 
              size="lg"
              className="bg-gray text-red-600 hover:bg-gray-100"
              icon="ri-phone-line"
              href="tel:+381600706072"
            >
              Pozovite Sada
            </Button>
            
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ServicesPage;